import React from 'react'
import { Box } from '@chakra-ui/react';

const Reports = ({ content }) => {
    return (
        <Box>
            {content}
        </Box>
    )
}

export default Reports